import Vue from 'vue'
import vueSeamlessScroll from 'vue-seamless-scroll'

Vue.use(vueSeamlessScroll)
